import { render, staticRenderFns } from "./CalculadoraProducto.vue?vue&type=template&id=90242706&scoped=true&"
import script from "./CalculadoraProducto.vue?vue&type=script&lang=js&"
export * from "./CalculadoraProducto.vue?vue&type=script&lang=js&"
import style0 from "./CalculadoraProducto.vue?vue&type=style&index=0&id=90242706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90242706",
  null
  
)

export default component.exports